import { PQrWaiterFulfillmentTime } from "./PQrWaiterFulfillmentTime";
import { POnlineFulfillmentTime } from "./POnlineFulfillmentTime";
export const PFulfillmentTime = {
    create(props) {
        if (props.purchaseOrderFulfillmentTime.type === "Online") {
            return new POnlineFulfillmentTime({
                purchaseOrderFulfillmentTime: props.purchaseOrderFulfillmentTime,
            });
        }
        else {
            return new PQrWaiterFulfillmentTime({
                fulfillmentInstructions: props.fulfillmentInstructions,
            });
        }
    },
};
